__turbopack_context__.v({
  "actions": "OnboardingModal-module__k0hOsa__actions",
  "body": "OnboardingModal-module__k0hOsa__body",
  "card": "OnboardingModal-module__k0hOsa__card",
  "dot": "OnboardingModal-module__k0hOsa__dot",
  "dotActive": "OnboardingModal-module__k0hOsa__dotActive",
  "dots": "OnboardingModal-module__k0hOsa__dots",
  "navGroup": "OnboardingModal-module__k0hOsa__navGroup",
  "next": "OnboardingModal-module__k0hOsa__next",
  "overlay": "OnboardingModal-module__k0hOsa__overlay",
  "prev": "OnboardingModal-module__k0hOsa__prev",
  "skip": "OnboardingModal-module__k0hOsa__skip",
  "title": "OnboardingModal-module__k0hOsa__title",
});
